// import qs from 'qs'
import axios from 'axios'

export const newReportService = ({
  getClientDashboard (token, objToPost) {
    return axios.post('/api/ReportV2/GetClientDashboardV2', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getMOTReport (token, objToPost) {
    return axios.post('/api/ReportV2/GetMOTReportV2', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getMissionReport (token, objToPost) {
    return axios.post('/api/ReportV2/GetMissonReportV2', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getMCQReport (token, objToPost) {
    return axios.post('/api/ReportV2/GetMCQReportV2', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getConsolidateMPElementSummary (token, objToPost) {
    return axios.post('/api/ReportV2/ConsolidateMPElementSummary', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getRecommendationSummaryReport (token, objToPost) {
    return axios.post('/api/ReportV2/RecommendationSummaryReport', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getRDReport (token, objToPost) {
    return axios.post('/api/ReportV2/RDReportV2', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getParticipantProgressReportV2 (token, objToPost) {
    return axios.post('/api/ReportV2/ProgressReportV2', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getRemainingProgressReport (token, objToPost) {
    return axios.post('/api/ReportV2/RemainingProgressData', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getALGReport (token, objToPost) {
    return axios.post('/api/ReportV2/GetALGReportV2', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getRecommendationAssessmentReport (token, objToPost) {
    return axios.post('/api/ReportV2/RecommendationReport', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getParticipantProgressReportV1 (token, objToPost) {
    return axios.post('/api/ReportV2/GetUserProgressData', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getParticipantViewProgressReport (token, objToPost) {
    return axios.post('/api/ReportV2/ParticipantViewProgressReport', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getCoursewiseElementViewProgressReport (token, objToPost) {
    return axios.post('/api/ReportV2/ElectiveViewProgressReportV2', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  scheduleNewReport (token, objToPost) {
    return axios.post('/api/ReportingTask/Create', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  listExistingScheduledReport (token) {
    return axios.get('/api/ReportingTask/ListAll', {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteExistingScheduledReport (token, reportingTaskId) {
    return axios.delete('/api/ReportingTask/Delete?reportingTaskId=' + reportingTaskId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateScheduledReport (token, objToPost) {
    return axios.put('/api/ReportingTask/Update', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  listGetAllGroupCourseCohort (token) {
    return axios.get('api/Group/GetAllGroupCourseCohort ', {headers: {'Authorization': 'Bearer ' + token}})
  }

})



// WEBPACK FOOTER //
// ./src/server-util/new-report-service.js